import { useEffect, useState } from "react";
import MultipleLineAndBarChart from "../../../components/charts/MultipleLineAndBarChart";
import { StatisticsSegmentedControl } from "./StatisticsPeriodToggle";

const CollectionFillingRateSection = ({
  dataSetsFillingLevelGroupedBar,
  labelsByFluxChart,
  dataSetsFillingLevelByTime,
  labelsByTimeChart,
  t,
  chartPlotRef,
  forceViewMode = null,
}) => {
  const [viewMode, setViewMode] = useState(() =>
    forceViewMode === "evolution" || forceViewMode === "average"
      ? forceViewMode
      : "average",
  );

  useEffect(() => {
    if (forceViewMode === "evolution" || forceViewMode === "average") {
      setViewMode(forceViewMode);
    }
  }, [forceViewMode]);

  const showEvolution = viewMode === "evolution";

  return (
    <article className="statistics-card min-lg:flex-[3] min-lg:min-w-0 flex flex-col min-h-0 h-full">
      <div className="dashboard-chart-heading dashboard-chart-heading-row shrink-0">
        <div className="dashboard-chart-heading-text">
          <h5 className="dashboard-chart-title">{t("Filling rate")}</h5>
          <p className="dashboard-chart-subtitle">
            {t("fillingRate.subtitle")}
          </p>
        </div>
        <StatisticsSegmentedControl
          value={viewMode}
          onChange={setViewMode}
          options={[
            { value: "average", label: t("fillingRate.averageByFlux") },
            { value: "evolution", label: t("fillingRate.evolution") },
          ]}
        />
      </div>

      <div className="relative w-full h-[320px] min-lg:h-auto min-lg:flex-1 min-lg:min-h-0">
        <div className="absolute inset-0" ref={chartPlotRef}>
          <MultipleLineAndBarChart
            key={showEvolution ? "evolution" : "average"}
            stackedChart={false}
            type={showEvolution ? "line" : "bar"}
            borderWidthChart={1}
            labelsChart={showEvolution ? labelsByTimeChart : labelsByFluxChart}
            aspectRatioChart={2.5}
            datasetsChart={
              showEvolution
                ? dataSetsFillingLevelByTime
                : dataSetsFillingLevelGroupedBar
            }
            indexAxisChart="x"
            maintainAspectRatioChart={false}
            displayGrid={true}
            displayTicks={true}
            xAxisType={showEvolution ? "time" : "category"}
            reverseChart={false}
            displayLegend={true}
            displayTooltip={true}
            messageLabelTooltip={t("of filling level")}
            unitValueChart="%"
            maxYAxis={100}
            barPercentageChart={0.85}
            categoryPercentageChart={0.55}
            timeUnitChart="month"
          />
        </div>
      </div>
    </article>
  );
};

export default CollectionFillingRateSection;
